import { includes, trim } from 'lodash';
import {
  BrowserTypesEnum,
  DeviceTypesEnum,
  IBrowserInfoHeaders,
  OSTypesEnum,
} from '../browser-manager.data';
import { environment } from '../../../environments';
import { IBrowserInfo } from '../reducers';

const isMobile = (parsedUserAgent: any): boolean => {
  const deviceType: string = parsedUserAgent.device.type;

  return deviceType === DeviceTypesEnum.MOBILE;
};

const isTablet = (parsedUserAgent: any): boolean => {
  const deviceType: string = parsedUserAgent.device.type;

  return deviceType === DeviceTypesEnum.TABLET;
};

const getPlatform = (parsedUserAgent: any): string => {
  const os = parsedUserAgent.os;

  return trim([os.name, os.version || ''].join(' '));
};

const isMacOS = (parsedUserAgent: any): boolean => {
  return includes(
    getPlatform(parsedUserAgent).toLowerCase(),
    OSTypesEnum.MACOS
  );
};

const getDevice = (parsedUserAgent: any): string => {
  const device = parsedUserAgent.device;

  if (!!device && !!device.vendor && !!device.model) {
    return device.vendor + '/' + device.model;
  } else {
    const browser = parsedUserAgent.browser;

    return trim([browser.name || '', browser.version || ''].join(' '));
  }
};

const isOnline = (navigator: any): boolean => {
  return navigator.onLine;
};

const isIE = (parsedUserAgent: any): boolean => {
  const browserName = parsedUserAgent.browser.name;

  return (
    browserName === BrowserTypesEnum.IE || browserName === BrowserTypesEnum.EDGE
  );
};

const isFirefox = (parsedUserAgent: any): boolean => {
  const browserName = parsedUserAgent.browser.name;

  return browserName === BrowserTypesEnum.FIREFOX;
};

const getBrowserInfoHeaders = (
  parsedUserAgent: any,
  deviceId: string
): IBrowserInfoHeaders => {
  return {
    'x-i2g-device': getDevice(parsedUserAgent),
    'x-i2g-device-id': deviceId,
    'x-i2g-platform': getPlatform(parsedUserAgent),
    'x-i2g-client': `Web/${environment.version}`,
  };
};

export const getBrowserData = (
  parsedUserAgent: any,
  navigator: any,
  deviceId: string
): IBrowserInfo => {
  return {
    isMobile: isMobile(parsedUserAgent),
    isMacOS: isMacOS(parsedUserAgent),
    isFirefox: isFirefox(parsedUserAgent),
    isIE: isIE(parsedUserAgent),
    isOnline: isOnline(navigator),
    device: getDevice(parsedUserAgent),
    isTablet: isTablet(parsedUserAgent),
    platform: getPlatform(parsedUserAgent),
    browserInfoHeaders: getBrowserInfoHeaders(parsedUserAgent, deviceId),
  };
};
